import React, { createContext, useContext, useState } from 'react';

import { defaultDateRange } from './util';

type DateRange = {
  startDate?: number;
  endDate?: number;
};

type MeetingHubFiltersContextType = {
  selectedDateRange: DateRange;
  setSelectedDateRange: React.Dispatch<React.SetStateAction<DateRange>>;
  selectedParticipants: string[];
  setSelectedParticipants: React.Dispatch<React.SetStateAction<string[]>>;
  participantSearchValue: string;
  setParticipantSearchValue: React.Dispatch<React.SetStateAction<string>>;
};

const MeetingHubFiltersContext = createContext<MeetingHubFiltersContextType | undefined>(undefined);

export const MeetingHubFiltersProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>(defaultDateRange);
  const [selectedParticipants, setSelectedParticipants] = useState<string[]>([]);
  const [participantSearchValue, setParticipantSearchValue] = useState('');

  return (
    <MeetingHubFiltersContext.Provider
      value={{
        selectedDateRange,
        setSelectedDateRange,
        selectedParticipants,
        setSelectedParticipants,
        participantSearchValue,
        setParticipantSearchValue
      }}
    >
      {children}
    </MeetingHubFiltersContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useMeetingHubFilters = () => {
  const context = useContext(MeetingHubFiltersContext);
  if (!context) {
    throw new Error('useMeetingHubFilters must be used within a MeetingHubFiltersProvider');
  }
  return context;
};
